"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareResult = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const icons_1 = require("../../atoms/icons");
const typography_1 = require("../../shared/typography");
const react_i18next_1 = require("react-i18next");
const faCopy_1 = require("@fortawesome/pro-regular-svg-icons/faCopy");
const faCheck_1 = require("@fortawesome/pro-regular-svg-icons/faCheck");
const ShareResult = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const [isCopied, setIsCopied] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (!isCopied)
            return;
        setTimeout(() => setIsCopied(false), 2000);
    }, [isCopied]);
    const link = t("shareResult.link");
    const onClick = async () => {
        if (isCopied)
            return;
        try {
            if (!navigator.clipboard) {
                const input = document.createElement("input");
                input.value = link;
                input.focus();
                input.select();
                document.execCommand("copy");
                return;
            }
            await navigator.clipboard.writeText(link);
            setIsCopied(true);
        }
        catch (e) {
            setIsCopied(false);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { isCopied: isCopied, children: [(0, jsx_runtime_1.jsx)(typography_1.P, { children: t("shareResult.p") }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("input", { value: link, disabled: true }, void 0), (0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", icon: isCopied ? faCheck_1.faCheck : faCopy_1.faCopy, onClick: onClick }, void 0)] }, void 0)] }, void 0));
};
exports.ShareResult = ShareResult;
const Wrapper = styled_components_1.default.div `
  position: relative;
  text-align: center;
  width: 812px;

  p,
  input {
    font-size: 0.875rem;
  }

  p {
    color: ${({ theme }) => theme.colors.greyBase};
    margin-bottom: 0.5rem;
  }

  a {
    color: ${({ theme }) => theme.colors.blueBase};
  }

  & > div {
    align-items: center;
    background-color: ${({ theme }) => theme.colors.silverBase};
    border: 1px solid ${({ theme }) => theme.colors.greyLighten40};
    border-radius: ${({ theme }) => theme.utils.radius};
    display: inline-flex;
    justify-content: space-between;
    overflow: hidden;

    & input {
      border-right: 1px solid
        ${({ theme }) => theme.colors.greyLighten40};
      flex: 1;
      padding: ${({ theme }) => `${theme.spacings.xs} ${theme.spacings.xs}`};
      width: 18rem;
    }

    & div {
      cursor: pointer;
      flex: 0;
      padding: ${({ theme }) => `0 ${theme.spacings.xs}`};
      width: 1.875rem;

      svg {
        color: ${({ theme }) => theme.colors.greyBase};
      }
    }
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    padding: ${({ theme }) => theme.spacings.m};
    width: unset;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.phoneSmall}) {
    padding-top: ${({ theme }) => theme.spacings.s};
  }
`;
//# sourceMappingURL=ShareResult.js.map